import React from "react";
import '../../App.css';

export default function Projects() {
    return <h1 className="ph-text">Projects showcase coming soon!</h1>;
}